// tel:-Verweis aus einer Nummer in beliebiger Schreibweise (#105, seit #255
// auch von der Kontaktsuche benutzt). Nur Ziffern und ein führendes „+“
// bleiben stehen -- „0621 / 123 45“ wird zu tel:062112345.
export function telHref(num) {
  return `tel:${String(num || '').replace(/[^\d+]/g, '')}`;
}
